// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import React from 'react'
import { connect } from 'react-redux'
import { GeoJSONLayer, Popup } from 'react-mapbox-gl'
import { DOWNLOAD_TASK_TYPE } from '../../constants'
import { Spin } from 'antd'

const roadColors = {
  selectable: '#008a43',
  selected: '#e880b9',
  active: '#d63389'
}

export class Roads extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      selectedRoad: null
    }
  }

  handleRoadClick (e) {
    const { onRoadSelect } = this.props
    const { properties } = e.features[0]
    this.setState({
      selectedRoad: {
        ...properties,
        ...e.lngLat
      }
    })
    const { roadID } = properties
    const { coordinates: roadCoordinates } = e.features[0].geometry
    onRoadSelect({ roadCoordinates, roadID })
  }

  render () {
    const { visible, activeRoadId, geoJSON, loading, zoom } = this.props
    if (!visible) {
      return null
    }
    const { selectedRoad } = this.state
    const showRoadLoadTip = zoom && zoom[0] <= 13
    return (
      <>
        {showRoadLoadTip && (
          <div className='roads-warning-tip'>Mention: Roads data will not load in this zoom level.</div>
        )}
        <GeoJSONLayer
          lineOnClick={this.handleRoadClick.bind(this)}
          linePaint={{
            'line-width': ['get', 'width'],
            'line-color': ['get', 'color']
          }}
          data={geoJSON}
        />

        {selectedRoad && activeRoadId && (
          <Popup coordinates={[selectedRoad.lng, selectedRoad.lat]} anchor='bottom' offset={[0, -20]}>
            <span style={{ color: roadColors.selected, lineHeight: '30px', padding: '10px' }}>
              Selected:{selectedRoad.name}
            </span>
          </Popup>
        )}
        <ul className='road-legend'>
          {Object.keys(roadColors).map(key => (
            <li key={key}>
              {key}
              <span className='color' style={{ background: roadColors[key] }} />
            </li>
          ))}
        </ul>
        <Spin style={{ position: 'absolute', left: 0, right: 0, margin: 'auto', top: 20 }} spinning={loading} />
      </>
    )
  }
}

export default connect(
  ({ road, download, loading, map }) => ({
    ...road,
    visible: download.editingPreTask.jobType === DOWNLOAD_TASK_TYPE.ROAD,
    activeRoadId: download.editingPreTask.roadID,
    selectedRoadIds: download.preTaskList.filter(x => !!x.roadID).map(x => x.roadID),
    loading: loading.models.road
  }),
  ({ road, download }) => ({
    ...road,
    onRoadSelect: ({ roadID, roadCoordinates }) => download.updateEditingPreTask({ roadID, roadCoordinates })
  }),
  (stateProps, dispatchProps, props) => {
    const { selectedRoadIds, activeRoadId, roads } = stateProps
    const geoJSON = {
      type: 'FeatureCollection',
      features: roads.map(road => {
        const isSelected = selectedRoadIds.indexOf(road.id) > -1
        const isActive = activeRoadId === road.id
        const color = isActive ? roadColors.active : isSelected ? roadColors.selected : roadColors.selectable
        const width = isActive ? 5 : 4
        road.properties = { ...road.properties, color, width }
        return road
      })
    }
    return {
      ...{ ...stateProps, geoJSON },
      ...dispatchProps,
      ...props
    }
  }
)(Roads)
